module.exports = __webpack_public_path__ + "static/ContactBanner-473b5377491b1d2945b56839855ecfb5.jpg";